export default {
  UserGroup: {
    free: 'Free plan',
    professional: 'Pro plan',
    enterprise: 'Pro Plus plan',
    qihoo: 'Qihoo plan'
  }
}
